module.exports = __webpack_public_path__ + "img/中通跨境.f2f1847c.png";